export class TipoResolucion {
  Id: string | null;
  CreatedAt: string;
  Name: string;
  Content: string;
  FacultyId: string;
  OrderByFaculty: number;

  constructor() {
    this.Id = null;
    this.CreatedAt = '';
    this.Name = '';
    this.FacultyId = '';
    this.Content = '';
    this.OrderByFaculty = 0;
  }
}
